
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 3.2,
        rows: 1,
        slidesToScroll: 2,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 2.7,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2.1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.7,
              slidesToScroll: 1,
            },
          },

          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2.8,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1.9,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1.17,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      options: [
        {
          name: 'logo',
          label: 'Image',
          type: 'image',
        },
      ],
    }
  },
}
